export default {
  // common label
  'label.type': '类型',
  'label.name': '名称',
  'label.content': '内容',
  'label.remark': '备注',
  'label.createTime': '创建时间',
  'label.operation': '操作',
  'label.code': '编码',
  'label.date': '日期',
  'label.title': '标题',
  'label.status': '状态',
  'label.department': '部门',
  'label.endpoint': '终端类型',
  'label.username': '用户名',
  'label.unitName': '部门名称',
  'label.UID': 'UID',
  'label.email': '邮箱',
  'label.mobile': '手机号',
  'label.yes': '是',
  'label.no': '否',
  'label.logout': "退出",
  'label.import': '导入',
  'label.export': '导出',
  'label.delete': '删除',
  'label.InvoiceNO': '发票号码',
  'label.CDF': '报关单',
  'label.Expiredate': '到期日期',
  'label.CDD': '申报日期',
  'label.ReturnCDF': '复进口报关单号',
  'label.ReturnCDD': '复进口申报日期',
  'label.Alertdate': '预警日期',
  'label.CarModel': '车辆型号',
  'label.WaybillNO': '提运单号',
  'label.Type/LOT': '批次',
  'label.ContainerNO': '集装箱号',
  'label.CDFNO': '报关单号',
  'label.ReturnWaybillNO': '复进口提运单号',
  'label.ReturnContainerNO': '复进口集装箱号',
  'label.ReturnCDFNO': '复进口报关单号',
  'label.Return': '复进口-批次',
  'label.PartNO': '部件号码',
  'label.Notes': '备注',
  "label.ExportReviewResult": '出口复核结果',
  "label.ReturnImportReviewResult": '复进口复核结果',
  "label.ExportResult": '出口复核',
  "label.ReturnResult": '进口复核',
  "label.DescriptionEN": "描述（英文）",
  "label.DescriptionCN": '描述（中文）',
  "label.DataStatus": "数据状态",
  "label.singinid": "SIGNI ID",
  "label.SerialNumber": '序号',
  "label.DownloadTemplate": '导入模板下载',
  "label.UpdateBatch": '更新批次',
  "label.MarkasCompleted": '标记完成',
  "label.Delete": '删除',
  'label.permission': '按钮权限',
  // common button
  'button.search': '查询',
  'button.reset': '重置',
  'button.cancel': '取消',
  'button.save': '保存',
  'button.add': '添加',
  'button.import': '导入',
  'button.export': '导出',
  'button.ok': '确定',
  'button.synchronize': '同步',
  'button.submit': '提交',
  'button.confirm': '确定',
  'button.details': '详情',
  'button.edit': '编辑',
  'button.delete': '删除',

  //
  'column.title': '修改',
  // common message
  'message.add': '添加成功',
  'message.edit': '编辑成功',
  'message.delete.confirm': '确认要删除该记录吗？',
  'message.delete.success': '删除记录成功。',
  'message.rule': '当前信息格式不正确。',
  'message.read.success': '操作成功',
  'message.async.title': '确认要同步权限吗？',
  'message.async.success': '权限同步成功',
  'message.back': '返回首页',

  // table label
  'label.table.title': '结果包含',
  'label.table.items': '项',
  'label.table.edit': '编辑',
  'label.table.delete': '删除',
  'label.table.detail': '详情',
  'label.table.permission': '权限',
  'label.table.notes': '备注',

  // placeholder
  'placeholder.select': '请选择',
  'placeholder.input': '请输入',
  'placeholder.Startdate': '开始日期',
  'placeholder.Enddate': '结束日期',
  'placeholder.StartMonth': '开始月份',
  'placeholder.EndMonth': '结束月份',

  // Audit
  'label.audit.detail': '审计日志详情',

  // Delegation
  'label.delegation.id': '代理人UID',
  'label.delegation.name': '代理人姓名',
  'label.delegation.list': '代理人列表',
  'label.delegation.startDate': '开始日期',
  'label.delegation.endDate': '结束日期',
  'label.delegation.add': '添加代理',
  'label.delegation.edit': '编辑代理',

  'label.delegation.authorizer.id': '授权人工号',
  'label.delegation.authorizer.name': '授权人姓名',

  'rule.delegation.id': '代理人工号不能为空！',
  'rule.delegation.startTime': '开始时间不能为空！',
  'rule.delegation.endTime': '结束时间不能为空！',

  // Dict
  'label.dict.table': '字典表',
  'label.dict.key': '主键',
  'label.dict.cn': '中文',
  'label.dict.en': '英文',
  'label.dict.add': '添加字典',
  'label.dict.edit': '编辑字典',

  'rule.dict.code': '请输入字典编码',
  'rule.dict.name': '请输入字典名称',

  // Notification
  'label.notification.handle': '处理',
  'label.notification.ignore': '已读',
  'label.notification.read': '已读',
  'label.notification.unread': '未读',
  'label.notification.clear': '清空通知',
  'label.notification.more': '查看更多',

  // Department
  'label.department.title': '查看部门信息',
  'label.department.unit.name': '部门名称',
  'label.department.unit.id': '部门编号',
  'label.department.short.name': '部门简称',
  'label.department.parent.id': '父级部门',

  // permission
  'label.permission.name': '权限名称',
  'label.permission.code': '权限编码',
  'label.permission.action': '权限动作',
  'label.permission.data': '数据权限',
  'label.permission.title': '权限',
  'label.permission.description': '权限描述',

  // Role
  'label.role.code': '角色编码',
  'label.role.name': '角色名称',
  'label.role.isGlobal': '全局角色',
  'label.role.enabled': '启用',
  'label.role.disabled': '禁用',
  'label.role.description': '角色描述',
  'label.role.add': '新增角色',
  'label.role.edit': '编辑角色',
  'label.role.permission': '编辑权限',

  'rule.role.code': '角色编码不能为空！',
  'rule.role.name': '角色名称不能为空！',
  'rule.role.model': '所在企业不能为空！',

  // user
  'label.user.add': '新增用户',
  'label.user.edit': '修改用户',
  'label.user.roles': '角色列表',

  'rule.user.name': '用户名不能为空！',
  'rule.user.uid': 'uid不能为空！',
  'rule.user.deptCode': '部门名称不能为空！',
  'rule.user.email': 'email不能为空！',
  'rule.user.email.type': 'email格式不正确！',
  'rule.user.mobile': '手机号不能为空！',
  'rule.user.mobile.type': '手机号格式不正确！',

  // container
  'label.menu.search': '查询条件',
  'label.menu.table': '结果展示',
  'label.menu.close': '关闭',
  'label.menu.open': '展开',

  // menu
  'menu.home': '首页',
  'menu.system': 'BCS关务模块',
  'menu.system.rbac': '权限系统',
  'menu.rbac.user': '用户管理',
  'menu.rbac.role': '角色管理',
  'menu.rbac.permission': '权限管理',
  'menu.rbac.department': '部门管理',
  'menu.system.notification': '通知管理',
  'menu.system.syslog': '操作日志',
  'menu.system.dictionary': '数据字典',
  'menu.system.audit': '审计日志',
  'menu.system.delegation': '代理授权',
  'menu.system.notFound': '对不起，你访问的页面不存在',
  'menu.system.jobManager': '任务管理',
  'menu.system.homgpage': 'BCS关务模块',
  'menu.system.customs': '配件报关',
  'menu.cus.rack': 'RACK追踪报表',
  'menu.system.dpcard': '危包证追踪',
  'menu.dpcard.ledger': '工厂包装信息确认',
  'menu.dpcard.tocq': '危包证追踪',
  'menu.system.filemg': '文件管理',
  'menu.filemg.filemg': '文件管理',
  'menu.filemg.pdoc': '性能单管理',
  'menu.filemg.dpEPart': '文件上传',
  'menu.filemg.dpSeach': '文件查询',
  'menu.filemg.dpInspledger': '查验台账',
  'menu.filemg.dpFReport': '厂检报告1',
  'menu.system.psettings': '参数设置',
  'menu.psettings.dppqconfig': '包装-零件参数设置',
  'menu.system.dpexport': '原产地证申报',
  'menu.dpexport.dpEPart': '原产地证管理',
  'menu.dpexport.dpEBasic': '申报基础数据',
  'menu.dpexport.dpTJP': 'TJP接口数据',
  'menu.dpexport.dpEBasicDetails': '申报基础数据详情',
  'menu.dpexport.dpTJPDetails': 'TJP接口数据详情',
  'menu.dpexport.Uploadlogs': '上传日志',
  'menu.dpexport.new': '原产地证-新增',
  'menu.dpexport.edit': '原产地证-编辑',
  'menu.dpexport.details': '原产地证-详情',
  'menu.dpexport.dptoconfigure': '原产地证类型配置',
  'menu.dpexport.exchange': '征税汇率表',
  'menu.dpexport.dptocondeclare': '原产地证申报文件',
  'menu.dpexport.billmanagement': '提运单管理',
  'menu.dpexport.dptoconadministration': '原产地证模板管理',
  'menu.dpexport.dptocontemplates.add': '新增原产地证模板',
  'menu.dpexport.dptocontemplates.edit': '编辑原产地证模板',
  'menu.dpexport.dptocontemplates.detail': '详情原产地证模板',
  'menu.system.dpShipNoCertificate': '危包证申请',
  'menu.dpShipNoCertificate.dpShipNotice': '工厂出货通知',
  'menu.dpShipNoCertificate.dpGoodsCert': '危包证申请',
  'menu.system.partnermanagement': '合作伙伴管理',
  'menu.partnermanagement.partner': '合作伙伴管理',
  'menu.system.partsmanagement': '零件管理',
  'menu.partsmanagement.parts': '零件管理',
  'menu.partsmanagement.partsbom': '零件产品成本明细',
  'menu.partsmanagement.details': '零件产品成本明细-详情',
  'menu.partsmanagement.detailsbom': '零件产品成本明细-详情',
  'menu.partsmanagement.ftastatement': '原产地声明管理',
  'menu.partsmanagement.fileUploadlogs': '上传日志',
  'menu.system.prereview': '预审信息',
  'menu.prereview.administration': '预审信息管理',
  'menu.prereview.partsdetails': '预审关联零件明细',
  'menu.prereview.partsdbometails': '零件产品成本明细-详情',
  'menu.prereview.historicalformation': '历史预审信息',
  'menu.prereview.historicaldetails': '历史预审明细',
  'menu.prereview.details': '预审信息-详情',
  'menu.prereview.maintenancedetails': '预审信息-申请单号维护',
  'menu.system.settingstype': '系统设置',
  'menu.settingstype.syslog': '操作日志',
  'menu.settingstype.mapping': '申报文件关系设置',
  'menu.settingstype.check': '校验设置',
  'menu.prereview.bometails': '零件产品成本明细-详情',
  'menu.prereview.historytails': '历史预审信息-详情',
  'menu.prereview.historybomtails': '零件产品成本明细-详情',
  'menu.prereview.historiesbomtails': '零件产品成本明细-详情',
  'menu.system.datareview': '数据复核',
  'menu.datareview.reviewbom': '预审零件复核记录',
  'menu.datareview.resultdetails': '预审零件复核记录',
  'menu.datareview.ledger': '抽检台账',
  'menu.datareview.bometails': '数据复核',
  'menu.datareview.bomed': '零件产品成本明细-详情',
  'menu.datareview.bomeq': '预审信息详情',
  'menu.datareview.reviewresults': '复核结果明细',
  'menu.datareview.reviewresultsbom': '复核结果零件产品成本明细-详情',
  'menu.datareview.ledgers': '抽检台账',
  'menu.datareview.frequency': '复核频率设置',
  'menu.system.onlineStamp': '电子章',
  'menu.onlineStamp.exemptionInfos': '豁免管理',
  'menu.system.exportFileReviewLedger': '出口文件复核台账',
  'menu.system.dgcbusiness': '危包证业务',
  'menu.system.fta': '原产地证业务',
  'menu.system.documentseal': '出口文件盖章',
  'menu.system.fileUploadlogs': '出口文件上传日志',
  'menu.system.goods': '危包文件盖章',
  'menu.system.reImportDocumentStamping': '复进口文件盖章',
  'menu.system.reImportReviewLedger': '复进口文件复核台账',
  'menu.system.stampPosition': '盖章位置配置',
  'menu.system.temporaryIE': '暂时进出口业务',
  'menu.temporaryIE.tieExtensionRecord': '延期记录',
  'menu.temporaryIE.goodsQuantityConfig': '货物数量配置',
  'menu.temporaryIE.cusExportDraft': '出口报关单草单管理',
  'menu.temporaryIE.fileUploadlogs': '出口报关单草单管理-上传日志',
  'menu.temporaryIE.temporaryieLedgerDetails':'暂时进出口台账',
  'menu.temporaryIE.temporaryieDocumentSummary':'暂时进出口文件汇总',
  //任务管理
  'label.jobManager.jobName': '任务名称',
  'label.jobManager.jobGroup': '任务组',
  'label.jobManager.cron': 'Cron表达式',
  'label.jobManager.description': '描述',
  'label.jobManager.status': '状态',
  'label.jobManager.misfireType': 'misfire策略',
  'label.jobManager.schedulerJobStatus': '任务运行状态',
  'button.jobManager.delete': '删除',
  'button.jobManager.pause': '暂停',
  'button.jobManager.runOnce': '运行一次',
  'button.jobManager.resume': '重启',
  'rule.jobManager.jobName': '任务名称不能为空！',
  'rule.jobManager.jobGroup': '任务组不能为空！',
  'rule.jobManager.cron': 'Cron表达式不能为空！',
  'rule.jobManager.misfireType': 'misfire策略不能为空！',
  'rule.jobManager.status': '状态不能为空！',
  'rule.jobManager.jobMapKey': 'Key不能为空！',
  'rule.jobManager.jobMapValue': 'Value不能为空！',
  'label.jobManager.add': '新增任务',
  'label.jobManager.enabled': '开启',
  'label.jobManager.disabled': '暂停',
  'label.jobManager.jobMaps': '任务参数',
  'label.jobManager.misfireType.MISFIRE_INSTRUCTION_IGNORE_MISFIRE_POLICY': '所有的misfile任务马上执行',
  'label.jobManager.misfireType.MISFIRE_INSTRUCTION_FIRE_ONCE_NOW': '合并部分misfire',
  'label.jobManager.misfireType.MISFIRE_INSTRUCTION_DO_NOTHING': '放弃misfire',
  'label.onlineStamp.exemptionInfos.exemptionName': '豁免名称',
  'label.onlineStamp.exemptionInfos.exemptionId': '豁免ID',
  'label.onlineStamp.exemptionInfos.exemptionType': '豁免类型',
  'label.onlineStamp.exemptionInfos.effectiveDate': '生效日期',
  'label.onlineStamp.exemptionInfos.expiryDate': '失效日期',
  'label.onlineStamp.exemptionInfos.remark': '备注',

  'menu.system.taxSaving': '节税报表',
  'menu.taxSaving.taxSavingPayableRateSetting': '应缴税率维护',
  'menu.taxSaving.TaxSavingReport': '节税报表',

  //Fta
  'label.fta.management.AiPartNo': "AI零件号",
  Fta: {
    // 通用占位符 (如果您的项目中还没有)
    placeholder: {
      input: '请输入',
      select: '请选择',
    },
    // 通用按钮 (如果您的项目中还没有)
    button: {
      search: '搜索',
      reset: '重置',
      cancel: '取消',
      confirm: '确定',
    },
    // 通用标签 (如果您的项目中还没有)
    label: {
      operation: '操作',
      table: {
        edit: '编辑',
      },
    },

    partsMgmt: {
      // 搜索面板
      search: {
        aiPartNo: 'AI零件号',
        proposedHSCode: '建议HS编码',
        supplier: '供应商',
        partNameCn: '零件名称（中文）',
        partNameEn: '零件名称（英文）',
        isOrigin: '是否原产',
        partStatus: '零件状态',
        preAuditInfoStatus: '预审信息状态',
      },

      // 顶部操作按钮
      button: {
        partsSync: '零件同步',
        byVehicleModel: '按车型',
        byAIPartNo: '按AI零件号',
        add: '新增',
        importParts: '导入零件',
        notifyToUploadCostCertificate: '上传成本证明通知',
        importHSCode: '导入HS编码',
        generatePreAuditInfo: '生成预审信息',
        batchGeneratePreAuditInfo: '批量生成预审信息',
        partStatusToggle: '零件状态开关',
        delete: '删除',
      },

      // 表格列标题
      table: {
        preAuditInfoStatus: '预审信息状态',
        partStatus: '零件状态',
        vehicleModel: '车型',
        partNo: '零件号',
        aiVersion: 'AI版本号',
        aiPartNo: 'AI零件号',
        partNameCn: '零件名称（中文）',
        partNameEn: '零件名称（英文）',
        supplier: '供应商（中文）',
        supplierEn: '供应商（英文）',
        suggestedHSCode: '建议HS编码',
        nonOriginBomPercent: '非原产成分-成本证明(%)',
        costCertificateConfirmed: '成本证明-已确认',
        nonOriginPreAuditPercent: '非原产成分-预审(%)',
        preAuditRequestNo: '预审申请单号',
        isOrigin: '是否原产',
        isRVCApplicable: '是否适用RVC',
        isCTCApplicable: '是否适用CTC',
        originStandard: '原产地标准',
        originSubStandard: '原产地子标准',
      },

      // 工具提示
      tooltip: {
        nonOriginFOB: "'非原产成分'指非原产占FOB的百分比；RVC标准为BCS自定义RVC标准",
      },

      // 弹窗
      dialog: {
        syncPartsInfo: {
          title: '同步零件信息',
          tip1: '选择该车型后，系统会将“物料”中该车型的全部零件号同步至零件管理中；',
          tip2: '零件信息同步结果将以邮件形式通知您，无需停留在当前页面等待；',
          tip3: '接收到通知邮件前，请不要重复操作。',
          vehicleModel: '车型',
        },
      },
    },
    // === 2. 成本证明管理 (Cost Cert Mgmt) 模块 ===
    costCertMgmt: {
      // 页面标题 (基于截图)
      title: '成本证明管理',

      // 搜索面板
      search: {
        aiPartNo: 'AI零件号',
        cnDescription: '零件名称（中文）',
        complianceCheck: '成本证明自检情况',
        dataStatus: '数据状态',
        enDescription: '零件名称（英文）',
        supplier: '供应商',
        bcsRvcCompliance: '是否符合BCS-RVC要求',
      },

      // 顶部操作按钮
      button: {
        importCostCertificate: '导入成本证明',
        dataValidation: '数据自检',
        validateAndConfirm: '数据确认',
        delete: '删除',
        export: '导出',
        exportBaseInfo: '导出基础信息',
        exportCostCertDetail: '导出成本证明详情',
        downloadZipFile:'批量下载成本证明'
      },

      // 表格列标题
      table: {
        vehiclePlatform: '车型',
        partNo: '零件号',
        aiVersion: 'AI版本号',
        aiPartNo: 'AI零件号',
        cnDescription: '零件名称（中文）',
        enDescription: '零件名称（英文）',
        drawingNo: '图纸号',
        supplier: '供应商（中文）',
        supplierEn: '供应商（英文）',
        version: '版本',
        dataStatus: '数据状态',
        validationResult: '自检情况',
        bcsRvcCompliance: '是否符合BCS-RVC',
        nonOriginatingMaterials: '非原产占 FOB百分比(%)',
        confirmationDate: '确认日期',
        details: '详情',
        viewFile: '查看文件',
      },

      // 弹窗
      dialog: {
        systemTip: {
          title: '系统提示',
          tip1: '确认进行零件产品成本明细自检吗？',
          tip2: '系统将后台执行自检逻辑，自检结果将在“自检情况”列展示。',
        },
        validationTip: {
          title: '自检提示',
          selfProject: '自检项目',
          systemCalc: '系统计算',
          userCalc: '用户填报',
          validationResult: '自检结果',
        },
      },
    },
    // === 3. 原产声明管理 (Origin Declaration Mgmt) 模块 ===
    originDeclMgmt: {
      // 页面标题 (基于截图)
      title: '原产声明管理',

      // 搜索面板
      search: {
        aiPartNo: 'AI零件号',
        fileStatus: '文件状态',
        supplier: '供应商',
        fileType: '文件类型',
      },

      // 顶部操作按钮
      button: {
        uploadFile: '上传文件',
        bulkUploadFile: '批量上传文件',
        uploadLog: '上传日志',
        sendReviewNotice: '发送审核通知',
        fileReview: '文件审核',
        sendReviewResultNotice: '发送审核结果通知',
      },

      // 表格列标题
      table: {
        dataStatus: '数据状态',
        fileStatus: '文件状态',
        aiPartNo: 'AI零件号',
        partNameEn: '零件名称（英文）',
        partNameCn: '零件名称（中文）',
        version: '版本',
        supplier: '供应商（中文）',
        supplierEn: '供应商（英文）',
        isOrigin: '是否原产',
        originRule: '原产地规则',
        fileType: '文件类型',
        fileName: '文件名称',
        auditRecord: '审核记录',
      },

      // 弹窗
      dialog: {
        uploadTip: {
          title: '系统提示',
          tip1: '当前预审信息已存在原产声明，重新上传文件将会替换当前原产声明。',
          tip2: '确定要继续上传文件吗？',
        },
        reviewNotice: {
          title: '系统提示',
          tip1: '点击【确认】后将邮件通知BCS关务审核选中文件，且文件不可更改',
          tip2: '确认发送审核通知吗？',
        },
        reviewResultNotice: {
          title: '系统提示',
          tip1: '点击【确认】后将邮件通知供应商文件审核结果',
          tip2: '确认发送审核结果通知吗？',
        },
        replaceFileTip: {
          title: '提示',
          tip: '选中数据已存在原产地声明/情况说明，重新上传文件将替换当前文件确认要继续上传文件吗？',
        },
      },
    },
    // === 4. 预审信息管理 (Pre-Certification Mgmt) 模块 ===
    preCertMgmt: {
      // 页面标题 (基于截图)
      title: '预审信息管理',

      // 搜索面板
      search: {
        suggestedHSCode: '建议HS编码',
        productNameCn: '产品中文名称',
        supplier: '供应商',
        dataStatus: '预审信息状态',
        preCertGenerationDate: '预审信息生成日期',
        filingDate: '备案日期',
        singleWindowApplicationNo: '单窗申请单号',
      },

      // 顶部操作按钮
      button: {
        updateRecParts: '更新推荐零件',
        notifyPreCert: '发送预审通知',
        confirmPreCert: '预审信息确认',
        delete: '删除',
        changeNameHSCode: '产品名称/HS编码变更',
        export: '导出',
      },

      // 表格列标题
      table: {
        dataStatus: '预审信息状态',
        singleWindowApplicationNo: '单窗申请单号',
        filingDate: '备案日期',
        productNameCn: '产品中文名称',
        suggestedHSCode: '建议HS编码',
        supplier: '供应商（中文）',
        supplierEn: '供应商（英文）',
        nonOriginatingMaterials: '非原产占 FOB百分比(%)',
        recommendedAIPartNo: '推荐AI零件号',
        rulesOfOrigin: '原产地规则',
        partCount: '零件数',
        notificationSendTime: '发送通知时间',
        preCertGenerationDate: '预审信息生成日期',
        details: '详情',
        editApplicationNo: '申请单号维护',
        viewFile: '查看文件',
      },

      // 弹窗
      dialog: {
        uploadTip: {
          title: '系统提示',
          tip1: '当前预审信息已存在原产声明，重新上传文件将会替换当前原产声明。',
          tip2: '确定要继续上传文件吗？',
        },
        changeNameHSCodeTip: {
          title: '系统提示',
          tip1: '确定变更选中的预审信息吗？',
          tip2: '发起变更流程后，需要重新开始零件归类、零件产品成本明细上传，重新进行商品预审流程，在此期间相关零件号无法申请原产地证。',
        },
      },
    },
    // === 5. 预审关联零件详情 (Pre-Certification Related Part Details) 模块 ===
    preCertRelParts: {
      // 页面标题 (基于截图)
      title: '预审关联零件详情',

      // 搜索面板
      search: {
        aiPartNo: 'AI零件号',
        partNameCn: '零件名称（中文）',
        supplier: '供应商',
        dataStatus: '预审信息状态',
        suggestedHSCode: '建议HS编码',
        singleWindowApplicationNo: '单窗申请单号',
        preCertGenerationDate: '预审信息生成日期',
        isRecommended: '推荐零件',
      },

      // 表格列标题
      table: {
        dataStatus: '预审信息状态',
        singleWindowApplicationNo: '单窗申请单号',
        isRecommended: '推荐零件',
        aiPartNo: 'AI零件号',
        version: '版本',
        partNameCn: '零件名称（中文）',
        partNameEn: '零件名称（英文）',
        suggestedHSCode: '建议HS编码',
        supplier: '供应商（中文）',
        supplierEn: '供应商（英文）',
        nonOriginatingMaterials: '非原产占 FOB百分比(%)',
        preCertGenerationDate: '预审信息生成日期',
        details: '详情',
      },
    },

    // === 6. 预审历史 (Pre-Certification History) 模块 ===
    preCertHist: {
      // 页面标题 (基于截图)
      title: '预审历史',

      // 搜索面板
      search: {
        suggestedHSCode: '建议HS编码',
        productNameCn: '产品中文名称',
        supplier: '供应商',
        preCertGenerationDate: '预审信息生成日期',
        filingDate: '备案日期',
        singleWindowApplicationNo: '单窗申请单号',
      },

      // 表格列标题
      table: {
        singleWindowApplicationNo: '单窗申请单号',
        filingDate: '备案日期',
        productNameCn: '产品中文名称',
        suggestedHSCode: '建议HS编码',
        supplier: '供应商（中文）',
        supplierEn: '供应商（英文）',
        nonOriginatingMaterials: '非原产占 FOB百分比(%)',
        recommendedPartNo: '推荐零件号',
        partCount: '零件数',
        rulesOfOrigin: '原产地规则',
        notificationSendTime: '发送通知时间',
        preCertGenerationDate: '预审信息生成日期',
        details: '详情',
        viewFile: '查看文件',
      },

      // 弹窗
      dialog: {
        selfCheckTip: {
          title: '系统提示',
          tip1: '确认进行零件产品成本明细自检吗？',
          tip2: '系统将后台执行自检逻辑，自检结果将在“自检情况”列展示。',
        },
      },
    },
    // === 7. 历史零件详情 (Historical Part Details) 模块 ===
    histPartDetails: {
      // 页面标题 (基于截图)
      title: '历史零件详情',

      // 搜索面板
      search: {
        aiPartNo: 'AI零件号',
        partNameCn: '零件名称（中文）',
        supplier: '供应商',
        suggestedHSCode: '建议HS编码',
        singleWindowApplicationNo: '单窗申请单号',
        isRecommended: '推荐零件',
        preCertGenerationDate: '预审信息生成日期',
      },

      // 表格列标题
      table: {
        singleWindowApplicationNo: '单窗申请单号',
        isRecommended: '推荐零件',
        aiPartNo: 'AI零件号',
        version: '版本',
        partNameCn: '零件名称（中文）',
        partNameEn: '零件名称（英文）',
        suggestedHSCode: '建议HS编码',
        supplier: '供应商（中文）',
        supplierEn: '供应商（英文）',
        nonOriginatingMaterials: '非原产占 FOB百分比(%)',
        preCertGenerationDate: '预审信息生成日期',
        details: '详情',
      },

      // 弹窗
      dialog: {
        selfCheckTip: {
          title: '系统提示',
          tip1: '确认进行零件产品成本明细自检吗？',
          tip2: '系统将后台执行自检逻辑，自检结果将在“自检情况”列展示。',
        },
        selfCheckDetails: {
          title: '系统提示',
          checkItem: '自检项目',
          systemCalculation: '系统计算',
          userReport: '用户填报',
          checkResult: '自检结果',
        },
      },
    },
    // === 8. 零件复核记录 (Part Verification Records) 模块 ===
    partVerifyRec: {
      // 页面标题 (基于截图)
      title: '零件复核记录',

      // 搜索面板
      search: {
        supplier: '供应商',
        recordCreationTime: '复核记录生成时间',
        costCertChanged: '复核时零件产品成本明细是否变化', // 截图显示 "Cost Certificate Changed"
        verificationMethod: '复核方式',
      },

      // 表格列标题
      table: {
        recordCreationTime: '复核记录生成时间',
        verificationStatus: '复核状态',
        verificationMethod: '复核方式',
        verificationDate: '复核日期',
        verifiedBy: '复核人',
        supplier: '供应商（中文）',
        supplierEn: '供应商（英文）',
        totalVerifiedParts: '复核零件总数',
        partsWithChanges: '有变化的零件数',
        startVerification: '开始复核',
        viewDetails: '查看复核结果', // 对应操作列的“查看复核结果”
      },
    },
    // === 9. 零件复核详情 (Part Verification Details) 模块 ===
    partVerifyDetails: {
      // 页面标题 (基于截图)
      title: '零件复核详情',

      // 按钮
      button: {
        batchQuery: '批量查询',
      },

      // 搜索面板
      search: {
        supplier: '供应商',
        aiPartNo: 'AI零件号',
        costCertChanged: '零件产品成本明细是否有变化',
        isCertificate: '是否制证',
        partNameCn: '零件名称（中文）',
        recordCreationTime: '复核记录生成时间',
      },

      // 表格列标题和相关内容
      table: {
        recordCreationTime: '复核记录生成时间',
        supplier: '供应商（中文）',
        supplierEn: '供应商（英文）',
        aiPartNo: 'AI零件号',
        partNameCn: '零件名称（中文）',
        suggestedHSCode: '建议HS编码',
        costCertChanged: '零件产品成本明细是否有变化',
        isRVCApplicable: '是否适用RVC',
        isCTCApplicable: '是否适用CTC',
        isCertificate: '是否制证',
        originStandard: '原产地标准',
        originSubStandard: '原产地子标准',
        auxiliaryItems: '辅助项',
        reviewVersion: '复核版本',
        updateVersion: '更新版本',
        nonOriginatingMaterials: '非原产占 FOB百分比(%)',
        viewCertLogic: '点击查看"是否制证"判定逻辑',
        tooltipContent: '若本次复核时零件产品成本明细有变化，则数据列表内容为该AI零件号最新成本证明的原产地规则判定结果，否则为该AI零件号复核版本成本证明的原产地规则判定结果。',
      },

      // 弹窗
      dialog: {
        originDeclarationTip: {
          title: '系统提示',
          tip1: '当前预审信息已存在原产声明，重新上传文件将会替换当前原产声明。',
          tip2: '确定要继续上传文件吗？',
        },
        certLogic: {
          title: '“是否制证”判定说明',
          originStatusTable: '原产状态表',
          dataReviewOriginResult: '数据复核原产判定结果',
          isRVCApplicable: '是否适用RVC',
          isCTCApplicable: '是否适用CTC',
          isCertificate: '是否制证',
        },
        batchQuery: {
          title: '批量查询',
          aiPartNo: 'AI零件号',
          partNameCn: '零件名称（中文）',
          placeholder: '请以分行或逗号(,)分隔输入',
        },
      },
    },

    // === 10. 抽检台账 (Inspection Ledger) 模块 ===
    inspectionLedger: {
      // 页面标题 (基于截图)
      title: '抽检台账',

      // 搜索面板
      search: {
        supplier: '供应商', // 对应截图中的“Inspected Supplier”
        inspectionDate: '抽检日期',
      },

      // 表格列标题和操作
      table: {
        inspectionStatus: '抽检状态',
        inspectedSupplier: '供应商名称（中文）',
        inspectedSupplierEn: '供应商名称（英文）',
        inspectionDate: '抽检日期',
        inspectionOfficer: '抽检执行人',
        attachmentCount: '附件数量',
        uploadAttachment: '上传附件',
        viewFile: '查看文件',
      },

      // 弹窗
      dialog: {
        originDeclarationTip: {
          title: '系统提示',
          tip1: '当前预审信息已存在原产声明，重新上传文件将会替换当前原产声明。',
          tip2: '确定要继续上传文件吗？',
        },
        changePartHS: {
          title: '系统提示',
          tip1: '确定变更选中的预审信息吗？',
          tip2: '发起变更流程后，需要重新开始零件归类、零件产品成本明细上传，重新进行商品预审流程，在此期间相关零件号无法申请原产地证。',
        },
      },
    },
    reviewFreqConfig: {
      title: '复核频率配置',
      search: {
        operator: '操作人',
      },
      table: {
        unit: '复核频率单位',
        frequency: '复核频率',
        notificationDate: '复核通知发送日期',
        remarks: '备注',
        operator: '操作人',
        operationTime: '操作时间',
      },
      dialog: {
        systemTip: '系统提示',
        originDeclTip1: '当前预审信息已存在原产声明，重新上传文件将会替换当前原产声明。',
        originDeclTip2: '确定要继续上传文件吗？',
        changeTip1: '确定变更选中的预审信息吗？',
        changeTip2: '发起变更流程后，需要重新开始零件归类、零件产品成本明细上传，重新进行商品预审流程，在此期间相关零件号无法申请原产地证。',
      }
    },
    declMasterData: {
      search: {
        proformaInvNo: '形式发票号',
        dataStatus: '数据状态',
        signiId: 'SIGNI ID',
        bolNo: '提单号',
        shipmentDate: '出运日期',
        proformaInvDate: '形式发票日期',
      },
      button: {
        batchUploadEdi: '批量上传EDI',
        uploadLog: '上传日志',
        importSigniId: '导入SIGNI ID',
        importAiPartNo: '导入AI零件号',
        importBolInfo: '导入提单信息',
        generateCoo: '生成原产地证',
        bolMaintenance: '提单维护',
        skipAndGenerate: '跳过以上发票继续生成',
      },
      table: {
        status: '数据状态',
        proformaInvNo: '形式发票号',
        commercialInvNo: '商业发票号',
        commercialInvDate: '商业发票日期',
        proformaInvDate: '形式发票日期',
        signiId: 'SIGNI ID',
        bolNo: '提单号',
        shipmentDate: '出运日期',
        vesselVoyage: '运输工具名称/航次',
        certNo: '证书号',
        creationTime: '数据创建时间',
      },
      dialog: {
        systemTip: '系统提示',
        selfCheckTitle: '自检提示',
        selfProject: '自检项目',
        systemCalc: '系统计算',
        userCalc: '用户填报',
        selfResult: '自检结果',
        verifyTip: '下列形式发票号必要的随附文件不完整,无法生成原产地证,请补充完整后重新操作',
        missingDoc: '缺失的随附文件',
      }
    },
    cooAppDocs: {
      search: {
        proformaInvNo: '形式发票号',
        signiId: 'SIGNI ID',
      },
      button: {
        viewFile: '查看文件',
      },
      table: {
        proformaInvNo: '形式发票号',
        signiId: 'SIGNI ID',
        proformaInv: '形式发票',
        packingList: '装箱单',
        contract: '合同',
        bol: '提运单',
        originalCoo: '原证书',
        thirdPartyInv: '第三方/非缔约方发票',
        exportDecl: '出口报关单',
        costStatement: '产品成本明细单',
        purchaseCert: '成品采购证明',
      }
    },
    blMgmt: {
      search: {
        blNo: '提单号',
        shipmentDate: '出运日期',
        conveyance: '运输工具名称/航次',
        status: '确认状态',
        invoiceNo: '形式发票号',
        batchSearch: '批量查询'
      },
      table: {
        invoiceNo: '形式发票号',
        blNo: '提单号',
        shipmentDate: '出运日期',
        conveyance: '运输工具名称/航次',
        status: '确认状态',
        confirmTime: '确认时间',
        creator: '创建人',
        creationTime: '创建时间'
      },
      actions: {
        importInfo: '导入提单信息',
        uploadFiles: '批量上传提运单文件',
        validateConfirm: '数据及文件确认',
        deleteData: '删除数据',
        deleteFiles: '删除文件',
        withdraw: '撤回',
        export: '导出'
      },
      dialog: {
        systemTip: '系统提示',
        batchSearch: '批量查询',
        byInvoice: '按形式发票号',
        byBL: '按提单号',
        inputPlaceholder: '请以分行或逗号(,)分隔输入',
        confirmMsg: '确认后的数据及文件将会用于进出口申请需要提运单的各个环节，请确保数据及文件无误。',
        withdrawMsg: '确定要撤回以下形式发票号对应的运单信息和文件吗？',
        deleteFileMsg: '以下提单号对应的形式发票号已在系统中完成数据及文件确认，不允许删除，如需更新，请撤回该提单号下所有形式发票号的提单信息及文件。',
        ftaLimitMsg: '以下形式发票号已经开始FTA制证，无法撤回，请线下联系BCS业务老师。',
        selfCheck: '自检提示',
        selfProject: '自检项目',
        systemCalc: '系统计算',
        userCalc: '用户填报',
        selfResult: '自检结果',
        index: '序号'
      }
    },
    cooMgmt: {
      title: '原产地证管理',
      search: {
        certNo: '证书号',
        invoiceNo: '形式发票号',
        commercialInvNo: '商业发票号',
        submissionTime: '申请时间'
      },
      actions: {
        add: '新增',
        validateConfirm: '数据确认',
        delete: '删除',
        batchUploadCert: '批量上传证书',
        UploadLog: '上传日志',
        uploadCert: '上传证书',
        uploadTracking: '上传快递单号',
        manageTracking: '快递单号维护',
        batchSave: '批量暂存',
        export: '导出',
        sendEmailToImporter:'邮件通知进口方',
        sendEmailToMYS:'马来西亚',
        sendEmailToIDN:'印度尼西亚',
        sendEmailToVNM:'越南',
      },
      table: {
        status: '数据状态',
        customsReceipt: '海关回执',
        receipt:'随附文件回执',
        certNo: '证书号',
        commercialInvNo: '商业发票号',
        proformaInvoiceNo: '形式发票号',
        signiId: 'SIGNIID',
        blNo: '提单号',
        certType: '证书类型',
        trackingNo: '快递单号',
        creationTime: '创建时间',
        submissionTime: '申请时间',
        customsCert: '海关证书',
        hasDraftPdf: '草单文件',
        edit: '编辑',
        saveToCustoms: '暂存',
        viewFile: '查看文件'
      },
      dialog: {
        showReceipt:'查看回执',
        certTypeTitle: '原产地证类型',
        receiptStatusTitle: '海关回执状态',
        systemTip: '系统提示',
        missingFieldsMsg: '下列原产地证缺少必填项，请将必填项补充完整，再进行数据确认。'
      },
      detail: {
        basicInformation: '基本信息',
        entityIdentificationCode: '主体标识码',
        companyNameInChinese: '公司中文名称',
        certificateNo: '证书号',
        commercialInvoiceNo: '发票号',
        invoiceDate: '发票日期',
        departureDate: '出运日期',
        issuingAuthority: '签证机关',
        certificateCollectionAuthority: '领证机关',
        placeOfApplication: '申请地址',
        dateOfApplication: '申请日期',
        declarantName: '申报员姓名',
        declarantIdNo: '申报员身份证号',
        declarantContactDetails: '申报员联系方式',
        importingCountryRegion: '进口国/地区',
        exporter: '出口商',
        consignee: '收货人',
        exhibitionIndicator: '展览标志',
        marksAndNumbersOnPackages: '唛头',
        specialTermsAndConditions: '特殊条款',
        portOfLoading: '启运港',
        portOfDischarge: '卸货港',
        meansOfTransport: '运输方式',
        vesselNameVoyageNo: '船名/航次',
        exportTradeMethod: '贸易方式',
        transitCountryRegion: '中转国家/地区',
        portOfTransshipment: '转运港',
        portOfDestination: '目的港',
        meansOfTransportAndRoute: '运输细节',
        applicationRemarks: '申请书备注',
        fobValueUsd: 'FOB值（美元）',
        totalAmount: '总金额',
        currency: '货币单位',
        specialInvoiceTerms: '发票特殊条款',
        tradeTermsIncoterms: '价格条款',
        contractNo: '合同号',
        letterOfCreditNo: '信用证号',
        thirdPartyInvoicingNonPartyCountryCompany: '第三方发票/非缔约方公司',
        itemNumber: '序号',
        countryRegion: '国别/地区',
        companyName: '企业名称',
        companyAddress: '企业地址',
        goodsInformation: '货物信息',
        nonGoodsItemSelectYesForMixedGoods: '非货物项（混装货物选择是）',
        hsCode: 'HS编码',
        nonOriginatingContent: '非原产成分',
        productNameInChinese: '货物中文名称',
        productNameInEnglish: '货物英文名称',
        descriptionOfProducts: '货物描述',
        originCriteria: '原产地标准',
        originSubCriteria: '原产地子标准',
        supplementaryFieldForOriginCriteria: '原产地标准辅助项',
        numberOfPackages: '包装件数',
        quantityWeightUnit: '数/重量单位',
        supplementaryQuantityUnit: '辅助数量/单位',
        secondSupplementaryQuantityUnit: '第二辅助数量/单位',
        invoiceUnitPrice: '发票单价',
        invoiceAmountFob: '(FOB)发票金额',
        manufacturerCode: '生产企业代码',
        manufacturerName: '生产企业名称',
        contactPerson: '联系人',
        contactPhoneNumber: '联系电话'
      }
    },
    cooReceipt:{
      title: '随附文件',
      table: {
        fileName: '文件名称',
        note: '文件传输结果'
      }
    },
    cooTemplate: {
      title: '原产地证模板管理',
      search: {
        templateName: '模板名称',
        status: '模板状态'
      },
      actions: {
        add: '新增',
        delete: '删除'
      },
      table: {
        templateName: '模板名称',
        templateType: '模板类型',
        creationTime: '创建时间',
        status: '状态',
      }
    },
    tjpData: {
      title: 'TJP 数据接口',
      search: {
        salesContract: 'noOfSalesContract',
        commercialInv: 'commercialInvoice',
        invDate: 'commercialInvDate',
        destCountry: 'destinationCountryId',
        creationTime: '创建时间',
        syncStatus: '数据同步状态',
        updateStatus: '数据更新状态'
      },
      actions: {
        sync: '同步',
        export: '导出'
      },
      table: {
        creationTime: '创建时间',
        updateStatus: '数据更新状态',
        syncStatus: '数据同步状态',
        syncTime: '同步时间',
        details: '详情',
        viewUpdates: '查看更新'
      },
      dialog: {
        systemTip: '系统提示',
        syncIneligibleMsg: '下列形式发票号不符合同步要求（目的国/地区：MY；贸易方式：0110），不允许同步；如需同步，请联系运维人员',
        syncDuplicateMsg: '下列形式发票号已在系统中制证，无法直接同步TJP数据，如需要重新制证，请先删除原产地证数据后再同步。',
        syncConfirmMsg: '确认同步所选的 {count} 条TJP数据至申报基础数据页面吗？',
        updateTitle: '数据更新（与上一版本相比）',
        fieldPosition: '字段位置',
        lineNumber: '商品序号',
        fieldName: '字段名称',
        newData: '更新数据',
        originalData: '原数据'
      }
    }
  }
};
